import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTargetArrowIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.47 3.205a.8.8 0 0 1 .223-.697l1.28-1.28a.4.4 0 0 1 .655.135l.575 1.437 1.438.575a.4.4 0 0 1 .135.655l-1.28 1.28a.8.8 0 0 1-.698.223l-1.267-.21-3.103 3.102a.6.6 0 0 1-.847-.847l3.102-3.103-.21-1.267zm2.16 3.515a2 2 0 0 0 1.546-.415A6.4 6.4 0 0 1 8.003 14.4a6.4 6.4 0 0 1-6.4-6.4 6.4 6.4 0 0 1 8.095-6.172 2 2 0 0 0-.415 1.545 4.801 4.801 0 1 0-1.28 9.428 4.8 4.8 0 0 0 4.628-6.08M8.004 4.4q.485.002.933.123L7.348 6.11a2 2 0 1 0 2.545 2.545l1.588-1.587q.121.447.122.932a3.601 3.601 0 0 1-7.2 0 3.6 3.6 0 0 1 3.6-3.6" })
});
export default SvgTargetArrowIcon;
